const en = {
  months: {
    short: {
      0: 'Jan',
      1: 'Feb',
      2: 'Mar',
      3: 'Apr',
      4: 'May',
      5: 'Jun',
      6: 'Jul',
      7: 'Aug',
      8: 'Sep',
      9: 'Oct',
      10: 'Nov',
      11: 'Dec'
    }
  },
  errorBoundary: {
    title: 'Something went wrong',
    message: 'This screen ran into a problem. Reload to continue.',
    reload: 'Reload'
  },
  session: {
    to_many_user_login:
      'Too many connections. Please logout other sessions to continue here.',
    connectionCheck: 'Unable to contact the server - ',
    connectionRestore: 'Restore the internet connection to sync changes',
    checkConnection: 'check your connection',
    tryAgain: ' and try again.'
  },
  signIn: {
    enter_name: 'Enter Name in Field',
    saved_msg: 'Saved Successfully'
  },
  clickScanConfirmation: {
    scan_confirmation_pop_msg:
      'This is a note to packer. Confirmation is reqiuired for this note.',
    scan_confirmation_pop_errormsg:
      'Enter or scan your confirmation code to continue'
  },
  AddNextBarcode: {
    search_item_msg:
      'Scan the item you would like to add to this order to continue.',
    confirmation_code_msg:
      'Please scan or enter the confirmation code of a user with Order Edit Permissions.'
  },
  scanpackItem: {
    shippingEsaySameOrderTextAlert:
      'The following orders share a similar order number. Click to swtich.',
    shipStationSameOrderText:
      'The following orders share the same order number. Click to swtich.',
    Scanpack_Item_tracking_msg:
      "Doh! The Tracking Number You have scanned does not appear to be valid. If you're certain it is correct please have an admin check your Tracking Number Validation setting in Settings > System > Scan & Pack > Post Scanning Functions.",
    Scanpack_Item_shipping_msg_two:
      'To override this verification, enter a confitmation code with Order Edit Permissions to continue.',
    // Scanpack_qty_exceed_msg_part1: "The quantity entered exceeds the remaining",
    // Scanpack_qty_exceed_msg_part2: "pieces in the order. Please try again",
    // Scanpack_success_msg: "Save Changes Successful",
    Scanpack_type_count_msg:
      'Please scan the item once before triggering a type-in count.',
    Disable_type_count_msg: 'The Type-in Count feature is disabled.',
    Disable_skip_msg: 'The Skip feature is disabled or wrong barcode entered.',
    Scanpack_multipack_msg:
      'The multi-pack barcode scanned exceeds the quantity remaining',
    Scan_correct_barocde: 'Please scan items in the suggested order',
    Scanpack_pass_fun_msg: 'The pass function is disabled',
    not_fulfilled_failed:
      'The item could not be marked not fulfilled. Check the connection and try again.',
    add_barcode_failed:
      'The barcode could not be saved. Check the connection and try again.',
    Scanpack_required_serial_msg:
      "The Value Scanned does not appear to be a Valid serial or lot number. Please check the 'Require Serial/Lot Prefix' setting in your scan and pack options.",
    Scanpack_barcode_found_or_special_code_msg:
      'The value entered matches a user confirmation code, one of the action barcodes or a product barcode. Please contact support if this value is required.',
    Scanpack_Item_Shipment: 'Shipment not found!',
    Scanpack_Item_Typecount_exceed_error:
      'The quantity entered exceeds the remaining number of pieces in the order. Please try again',
    addBar_text: 'Carefully check the item before scanning.',
    restartAlert:
      'Are you sure you would like to reset all scanning progress for this order?',
    service_Issue_msg: 'Service Issue Order',
    service_Issue_msg_one:
      'This order’s status is “Service Issue”. To change the status to “Awaiting” so it can be scanned please scan or enter your confirmation code. If you would like to scan a different order you can scan another order number to continue.',
    service_Issue_msg_two:
      'This order’s status is “Service Issue”. To change the status to “Awaiting” so it can be scanned please ask a team member with Order Edit permissions to scan or enter their confirmation code. If you would like to scan a different order you can scan another order number to continue.',
    service_Issue_notification: 'The confirmation code entered is not valid',
    service_Issue_notification_one:
      'The confirmation code entered is not associated with a user that has order edit permission.',
    refreshTooltip:
      'The import button will start an order import from all active order sources on the account. You can check the status of an import in progress using the refresh button.',
    addBarText: 'It will be saved and also marked scanned.',
    trackingSubmit: `The tracking number on the shipping label you just scanned does not match the tracking number imported with that order. Please verify that you have the correct shipping label and try your scan again. If you are aware of the issue and would like to proceed with the next order please scan your confirmation code to continue.`,
    moreToScanLabel: 'more to scan',
    outOfStockLabel: 'Report Out of Stock',
    scannedLabel: 'Scanned',
    uploadSyncLabel: 'Please connect to the internet to upload your scan data.',
    typeInCountLabel: 'Type-In Count'
  },
  nextItems: {
    passButtonLabel: 'Pass',
    scanAllLabel: 'SCAN\nALL',
    clickScanLabel: 'Click Here Before Scanning',
    tabHereLabel: 'Tap Here Before Scanning',
    readyForScanLabel: 'Ready For Product Scan',
    scanToteToContinue: 'Scan a tote to continue!',
    gotItLabel: 'Got it.',
    noOrderToScan: 'No order is present to scan',
    noItemsToScan: 'No more item remaining to scan',
    serialRecordingNote:
      'The next item requires a serial number to be recorded.',
    serialRecordingNoteTwo:
      'The next item requires two serial numbers to be recorded.',
    restartButton: {
      firstLabel: 'Restart',
      secondLabel: 'Order'
    },
    reloadButton: 'Reload',
    addNoteButton: {
      firstLabel: 'Add',
      secondLabel: 'Note'
    },
    activityLogLabel: 'Activity Logs',
    tryAgainLabel: 'Please try again',
    barcodeScanned: 'The barcode you have scanned',
    doesNotMatch:
      'does not match the tracking number imported with this order.',
    addBarCodeLabel: 'ADD A BARCODE',
    changesSaveLabel: 'Changes Successfully Saved',
    youLabel: 'You',
    leaderLabel: 'Leader',
    youAreInLead: 'You are in the lead ',
    unScannedLabel: 'Unscanned Items',
    scannedLabel: 'Scanned Items',
    unScannedLabelMobile: 'Unscanned',
    scannedLabelMobile: 'Scanned',
    not_fulfilled: 'Not Fulfilled',
    not_fulfilled_items: 'Not Fulfilled Items'
  },
  popupTracking: {
    noTracingFound: 'Unable to Verify Shipping Label',
    noUser_permission_text_one:
      'To continue you can scan a shipping label with a tracking number barcode that matches the tracking number associated with the current order, or you can override this verification by entering a confirmation code with Order Edit Permissions.',
    noUser_permission_text_two:
      'If neither of these options are available to you, you can close this notification and return to this order later to verify the shipping label. The order will be displayed in the Awaiting list until the shipping label is verified.',
    header: 'Please try again'
  },
  adminTools: {
    searchScopeSomeCustomer:
      'Searched the GroovePacker team band and the Customer band. Some matches are in the customer band, so {{tenant}} can see those.',
    searchScopeAllCustomer:
      'Searched the GroovePacker team band and the Customer band. All matches are in the customer band, so {{tenant}} can see them.',
    searchNoMatchesTitle: 'No settings match "{{query}}"',
    searchNoMatchesBody:
      'Searched names, tooltips and group names in both bands.',
    searchClear: 'Clear search',
    adminToolsTitle: 'Admin Tools',
    teamBandTitle: 'GroovePacker team only',
    teamBandDescription:
      'The customer never sees this band. These switches control plans, features and internal tools.',
    teamOnly: 'Team only',
    teamMenuTenants: 'Tenants',
    teamMenuUtilities: 'Utilities',
    teamMenuReportBug: 'Report a bug',
    teamMenuLogOut: 'Log Out',
    customerBandTitle: 'Customer settings',
    customerBandDescription:
      'The same settings {{tenant}} has on its own settings page. Changes here take effect for them straight away.',
    customerAlsoSees: 'Customer also sees',
    customerSeesThese: 'Customer sees these',
    bridgeLine: 'Everything below is also visible to {{tenant}}',
    searchPlaceholder: 'Search every setting by name, tooltip or group',
    searchPlaceholderShort: 'Search all settings',
    searchMatchCount: {
      one: '{{count}} match in {{groups}} {{groupsWord}}',
      other: '{{count}} matches in {{groups}} {{groupsWord}}'
    },
    searchGroupsWord: {
      one: 'group',
      other: 'groups'
    },
    groupMatchCount: {
      one: '1 match',
      other: '{{count}} matches'
    },
    searchScopeAllTeam:
      'Searched the GroovePacker team band and the Customer band. All matches are in the team band, so {{tenant}} cannot see them.',
    groupOnCount: '{{on}} of {{total}} on',
    movedFromCustomer: 'Moved from customer',
    movedFromCustomerLine: 'Moved from the customer settings page',
    saveFailed: "Couldn't save: {{error}}",
    unknownError: 'Unknown error',
    invalidNumber: 'Enter a valid number',
    minValue: 'Must be at least {{min}}',
    maxValue: 'Must be at most {{max}}',
    aboutSetting: 'About {{label}}',
    groupErrors: {
      one: '1 error',
      other: '{{count}} errors'
    },
    unknownSettingType: 'Unknown setting type "{{type}}" for "{{key}}"'
  },
  customerSettings: {
    maxTotesForSet: 'Maximum totes: {{name}}',
    userRoleLabel: '{{name}} · {{role}}',
    noStores: 'No stores connected',
    noUsers: 'No users',
    groupGeneral: 'General',
    groupGeneralDescription: 'Time zone, emails and alerts',
    timeZone: 'Time zone',
    timeZoneTooltip: 'Used for report times and scheduled imports.',
    billingNotificationEmail: 'Billing notification email',
    billingNotificationEmailTooltip:
      'Billing notices are sent here. Changing it also updates the email on the Stripe account.',
    outOfStockReportEmail: 'Out-of-stock report email',
    outOfStockReportEmailTooltip: 'Receives the out-of-stock report.',
    lowInventoryAlertLimit: 'Low inventory alert limit',
    lowInventoryAlertLimitTooltip:
      "Default alert level for products that don't have their own. An alert is sent when stock falls to this quantity or below.",
    groupScanPack: 'Scan & pack',
    groupScanPackDescription: 'Packing screen behavior',
    includeActionRequiredOrders: 'Include action-required orders',
    includeActionRequiredOrdersTooltip:
      'Shows orders that need action in the scan and pack queue.',
    suppressSoftwareKeyboard: 'Suppress software keyboard',
    suppressSoftwareKeyboardTooltip:
      'Hides the on-screen keyboard on scanner devices.',
    boxScanVerification: 'Box scan verification',
    boxScanVerificationTooltip:
      'Requires the packer to scan the box before closing an order.',
    orderNumberFallbackPrefixes: 'Order number prefixes to try',
    orderNumberFallbackPrefixesTooltip:
      'Prefixes tried when an order number is not found. Up to 10.',
    toteIdentifier: 'Tote identifier',
    toteIdentifierTooltip: 'Word shown for totes on the packing screen.',
    maxTotes: 'Maximum totes',
    maxTotesTooltip: 'Number of totes created for the scan to cart flow.',
    groupPrinting: 'Printing',
    groupPrintingDescription: 'Labels and packing slips',
    productBarcodeLabelSize: 'Product barcode label size',
    productBarcodeLabelSizeTooltip:
      'Size used when printing product barcode labels.',
    packingSlipSize: 'Packing slip size',
    packingSlipSizeTooltip: 'Paper size used for packing slips.',
    groupStores: 'Stores',
    groupStoresDescription: {
      one: '1 connected store',
      other: '{{count}} connected stores'
    },
    storeImportingHourly: 'Importing hourly',
    storeImportingEvery: 'Importing every {{minutes}} min',
    storeManual: 'Manual',
    listUnavailable: "Couldn't read this list from the server",
    storeInactive: 'Inactive',
    edit: 'Edit',
    groupUsers: 'Users',
    groupUsersDescription:
      '{{regular}} of {{regularLimit}} regular, {{admin}} of {{adminLimit}} admin-only',
    usersPillRegular: '{{count}}/{{limit}} regular',
    usersPillAdminOnly: '{{count}}/{{limit}} admin-only',
    userTagRegular: 'Regular',
    userTagAdminOnly: 'Admin-only',
    usersShowAll: 'Show all users'
  },
  adminTenantPage: {
    loading: 'Loading {{tenant}}...',
    loadFailedTitle: "Couldn't load {{tenant}}",
    loadFailedBody:
      "The server didn't answer ({{status}}). No settings are shown because none could be read, and nothing was changed.",
    loadFailedBanner:
      "Couldn't refresh this page. The settings shown may be out of date.",
    backToTenants: 'Back to tenants',
    dismiss: 'Dismiss',
    saveRejected: 'The server rejected the request',
    noSaveRoute: "This setting can't be saved from this page yet.",
    actionDone: 'Done',
    unknownValue: 'Unknown',
    noNote: 'No note',
    didNotSave: 'The server did not save this change.',
    noShopifyStore: 'This tenant has no Shopify store connected.',
    notFoundTitle: "{{tenant}} doesn't exist anymore",
    forbidden: 'Your account no longer has team access. Sign in again.',
    statusDeleted: 'Deleted',
    deletedBanner:
      "This tenant is deleted. Its users can't sign in, and its settings can't be edited here until it's restored.",
    saved: 'Saved',
    savedFor: 'Saved for {{tenant}}',
    billingConfirm: 'Confirm billing change',
    billingPerMonth: ' per month',
    billingPerYear: ' per year',
    billingAddonOn: 'Turn on {{addon}} for {{tenant}} at {{amount}}{{per}}?',
    billingAddonOff:
      'Turn off {{addon}} for {{tenant}}? It is currently {{amount}}{{per}}.',
    billingAddonAmount:
      'Change {{addon}} for {{tenant}} from {{from}} to {{to}}?',
    billingChargeAdded:
      "This adds {{amount}}{{per}} to {{tenant}}'s Stripe subscription. Nothing is charged right now. Stripe adds any prorated charge for the rest of this billing period to the next invoice; during a trial, billing starts when the trial ends.",
    billingChargeRemoved:
      "This removes the add-on from {{tenant}}'s Stripe subscription. Nothing is charged right now. Stripe credits any unused time on the next invoice.",
    billingNoCharge:
      'The add-on is off, so {{tenant}} is not charged. The new amount is used when it is turned on.',
    billingDoubleCharge:
      'Warning: {{tenant}} already pays {{from}}{{per}} for this add-on. Saving adds a second charge of {{to}}{{per}} and does not remove the {{from}} charge. Remove the old charge in Stripe by hand.',
    billingReprice:
      "Saving {{setting}} changes {{tenant}}'s subscription from {{from}} to {{to}}{{per}} (regular users × $50 + admin-only users × $10). Nothing is charged right now. Stripe adds any prorated difference to the next invoice; during a trial, the new price starts when the trial ends.",
    billingShopifyEmail:
      '{{tenant}} pays through Shopify. Saving {{setting}} emails them a request to approve their plan charge.',
    billingAddonNoStripe:
      '{{tenant}} has no Stripe subscription (it pays through Shopify or has none), so this is not billed in Stripe. Saving stores the add-on in GroovePacker.',
    billingNotApplied:
      'Stripe did not take the billing change for {{tenant}}. The setting is stored in GroovePacker, but the subscription in Stripe was not changed. Check it in Stripe.',
    billingChargeChanged:
      "Stripe changes {{tenant}}'s existing charge from {{from}} to {{to}}{{per}}. Nothing is charged right now. Stripe adds any prorated difference to the next invoice; during a trial, the new price starts when the trial ends.",
    billingErrorDetail: 'Details: {{error}}',
    billingRepriceNotApplied:
      "{{tenant}}'s new price was not recorded. The setting is stored in GroovePacker, but Stripe may have been partly changed. Check the subscription in Stripe.",
    billingRepriceRecorded:
      "GroovePacker recorded {{tenant}}'s new price of {{amount}}{{per}}. This page can't confirm Stripe applied it; check the subscription in Stripe if the save looked unusual.",
    billingNotConfirmed:
      'Billing not confirmed for {{tenant}}. The setting is stored in GroovePacker, but there is no way to tell from here whether Stripe applied the change. Check the subscription in Stripe.',
    sideEffectsTitle: 'Also done automatically',
    duplicate: 'Duplicate',
    statusActive: 'Active',
    testTenantOn: 'Test tenant: on',
    testTenantOff: 'Test tenant: off',
    statPlan: 'Plan',
    statShipmentsThisMonth: 'Shipments this month',
    statStores: 'Stores',
    countOfLimit: '{{count}} of {{limit}}',
    note: 'Note',
    deleteTenant: 'Delete tenant',
    restoreDeletedTenant: 'Restore deleted tenant',
    sideEffect: {
      inventory_process:
        'Inventory is being processed for every unscanned order.',
      users_packing_slip_size_reset:
        "Every user's packing slip size was changed to match.",
      inventory_unprocess:
        'Inventory is being unprocessed for every unscanned order.',
      stripe_billing_email_synced:
        'The email on the Stripe account was updated to match.',
      import_job_scheduled: 'The next scheduled import was set up.',
      tote_sets_rebuilt: 'Totes were rebuilt for the new maximum.',
      se_import_log_cleared: 'The saved store order import log was deleted.',
      schedule_import_mode_reset: 'The import schedule was reset to Daily.',
      dashboards_reset: "Every user's dashboard was reset to none.",
      shopify_limits_not_applied:
        'Shopify-billed tenant: the new limits were saved here but Shopify billing was not changed.',
      subscription_not_repriced_blank_id:
        'The Stripe subscription ID is blank, so the subscription price was not updated.',
      unknown:
        'The server reported an extra effect we have no description for: {{effect}}'
    },
    groupPlanBilling: 'Plan & billing',
    groupPlanBillingDescription: 'Plan, limits and billing-only add-ons',
    billingOnlyNote:
      'Billing only. These four switches change the invoice, not what the tenant can do.',
    addonPerUser: 'per user / month',
    addonMonthlyAmount: '= ${{amount}} / month',
    addonPerUserBreakdown: '{{count}} regular users × ${{price}}',
    addonFlat: 'Flat, once per month',
    addonNotBilled: 'Not billed',
    addonOff: 'Add-on is off',
    stripeSubLabel: 'Stripe',
    groupInventoryImport: 'Inventory & import controls',
    groupFeatures: 'Features',
    groupFeaturesDescription:
      'Switches that turn product features on for this tenant',
    groupWorkflow: 'Workflow & integrations',
    groupWorkflowDescription:
      'Scan workflow, post-scanning and Shopify API options',
    groupImportUtilities: 'Import utilities',
    groupImportUtilitiesDescription: 'Import behavior and support tools',
    groupLogging: 'Logging',
    groupLoggingDescription: 'Send events to Loggly for debugging',
    groupInventoryPush: 'Inventory push',
    groupInventoryPushDescription: 'Send stock levels back to the store'
  },
  tenantSettings: {
    importTime: 'Import time',
    scheduleOnOff: 'Run this schedule',
    invalidTime: 'Enter a time like 06:30',
    rangeOrder: 'The start hour must be before the end hour',
    addonPrice: 'Price',
    plan: 'Plan',
    planTooltip:
      "Subscription plan. Changing it updates this tenant's Stripe subscription.",
    highSku: 'High SKU',
    highSkuTooltip:
      "Billing add-on for high-SKU inventory. It doesn't turn on any feature.",
    doubleHighSku: 'Double High SKU',
    doubleHighSkuTooltip:
      "Billing add-on for double-high SKU shelving. It doesn't turn on any feature.",
    custMaintenance1: 'Custom maintenance 1',
    custMaintenance1Tooltip:
      "Billing add-on for custom maintenance services. It doesn't turn on any feature.",
    custMaintenance2: 'Custom maintenance 2',
    custMaintenance2Tooltip:
      "Billing add-on for additional custom maintenance services. It doesn't turn on any feature.",
    stripeCustomerId: 'Stripe customer ID',
    stripeCustomerIdTooltip: 'Only the gpadmin account can see and edit this.',
    stripeSubscriptionId: 'Stripe subscription ID',
    stripeSubscriptionIdTooltip:
      'Only the gpadmin account can see and edit this.',
    inventoryTracking: 'Inventory tracking',
    inventoryTrackingTooltip:
      'Turning this on or off reprocesses inventory for every unscanned order. It can take a while on large tenants.',
    generateNumericBarcodes: 'Generate numeric barcodes',
    generateNumericBarcodesTooltip:
      "Length and starting value for the barcodes GroovePacker generates. The first digit can't be 0.",
    numericBarcodeLength: 'Length',
    numericBarcodeStartValue: 'Start value',
    removeZeroQuantityItems: 'Remove order items with quantity of zero',
    removeZeroQuantityItemsTooltip:
      'Drops order lines whose quantity is 0 when orders are imported.',
    preDayImportSchedule: 'Pre-day order import schedule',
    preDayImportScheduleTooltip:
      'Imports orders once a day at the chosen time, or hourly when Hourly order import is on.',
    importModeDaily: 'Daily',
    importModeHourly: 'Hourly',
    recurringFtpImportRange: 'Recurring FTP order import range',
    recurringFtpImportRangeTooltip:
      'Hours of the day when FTP order imports may run.',
    rangeFrom: 'From',
    rangeTo: 'to',
    hourAm: 'AM',
    hourPm: 'PM',
    hourEndOfDay: '11:59 PM',
    multiBox: 'Multi-box',
    multiBoxTooltip:
      'Allows orders to be packed into multiple boxes instead of a single shipment.',
    boxChamp: 'BoxChamp',
    boxChampTooltip:
      'Lets BoxChamp pick the best box for each order to cut dimensional weight and shipping cost.',
    amazonFba: 'Amazon FBA',
    amazonFbaTooltip:
      'Enables Amazon FBA fulfillment so orders can ship to Amazon fulfillment centers.',
    realTimePackerStats: 'Real-time packer stats',
    realTimePackerStatsTooltip:
      'Shows live packing statistics for each packer on the dashboard.',
    hourlyOrderImport: 'Hourly order import',
    hourlyOrderImportTooltip:
      'Imports orders from connected stores every hour.',
    productFtpImport: 'Product FTP import',
    productFtpImportTooltip:
      'Imports product information into the catalog from an FTP server.',
    inventoryReportOption: 'Inventory report option',
    inventoryReportOptionTooltip:
      'Gives access to inventory status reports and history.',
    postScanningApiCall: 'Post-scanning API call',
    postScanningApiCallTooltip:
      'Calls an external webhook each time an item is scanned during packing.',
    groovelyticsStats: 'Groovelytics stats',
    groovelyticsStatsTooltip:
      'Tracks and displays scanning accuracy and performance metrics.',
    enableDeveloperTools: 'Enable developer tools',
    enableDeveloperToolsTooltip:
      'Grants access to the external developer API for custom integrations.',
    dailyPackedPercent: 'Daily packed %',
    dailyPackedPercentTooltip:
      'Enables the daily report of the percentage of orders packed and shipped.',
    postImportRulesEngine: 'Post-import rules engine',
    postImportRulesEngineTooltip:
      'Applies custom rules to orders right after import.',
    packingCam: 'Packing Cam',
    packingCamTooltip:
      'Captures photos during packing for quality records and customer service.',
    voicePacking: 'Voice packing',
    voicePackingTooltip:
      'Lets packers hear spoken packing instructions in GPX.',
    newScanPackInterface: 'New Scan & Pack interface',
    newScanPackInterfaceTooltip:
      'Switches the tenant to the newer scan-and-pack screen.',
    scanToScore: 'Scan to score',
    scanToScoreTooltip:
      'Shows packers a running score on the scan and pack screen as they scan.',
    scanWorkflow: 'Scan workflow',
    scanWorkflowTooltip:
      'Sets how packers work: Default, Product First, Multi Put Wall, Pick Tote or Scan to Cart.',
    scanWorkflowDefault: 'Default',
    scanWorkflowProductFirst: 'Product First',
    scanWorkflowMultiPutWall: 'Multi Put Wall',
    scanWorkflowPickTote: 'Pick Tote',
    scanWorkflowScanToCart: 'Scan to Cart',
    postScanningOptionsV2: 'Post-scanning options V2',
    postScanningOptionsV2Tooltip:
      'Runs post-scan actions in GPX, such as printing labels or updating tracking.',
    shopifyGraphqlOrderImport: 'Shopify GraphQL order import',
    shopifyGraphqlOrderImportTooltip:
      'Uses the faster Shopify GraphQL API for order imports instead of REST.',
    shopifyGraphqlProductImport: 'Shopify GraphQL product import',
    shopifyGraphqlProductImportTooltip:
      'Uses the Shopify GraphQL API for product imports.',
    shopifyGraphqlWrites: 'Shopify GraphQL writes (tags and fulfillment)',
    shopifyGraphqlWritesTooltip:
      'Writes fulfillment updates and tags back to Shopify through GraphQL.',
    shopifyTrackingLookup: 'Shopify tracking number lookup',
    shopifyTrackingLookupTooltip:
      'When a scanned tracking number matches no order, finds the Shopify order that carries it and imports it on demand. Needs Shopify GraphQL order import on.',
    shipworksImportWithDelay: 'ShipWorks import with delay',
    shipworksImportWithDelayTooltip:
      'Imports ShipWorks orders in delayed batches instead of one at a time.',
    inventoryUpdateWithDelay: 'Inventory update with delay',
    inventoryUpdateWithDelayTooltip:
      'Batches inventory updates in the background instead of per order.',
    showExternalLogsButton: 'Show external logs button',
    showExternalLogsButtonTooltip:
      'Shows a button for viewing external system logs.',
    orderCupDirectShipping: 'OrderCup direct shipping',
    orderCupDirectShippingTooltip:
      'Creates shipping labels directly from OrderCup CSV orders.',
    getOrderResponseLog: 'Save order response log',
    getOrderResponseLogTooltip:
      'Saves import response logs for debugging and audit.',
    gdprShipStation: 'GDPR ShipStation',
    gdprShipStationTooltip:
      'Redacts customer email and shipping address from ShipStation imports. Only the newer ShipStation import applies this today.',
    uniqueShopifyImport: 'Unique Shopify import',
    uniqueShopifyImportTooltip:
      "Stops a second Shopify order import from starting while one is already running, so orders aren't imported twice.",
    showOriginatingStoreId: 'Show originating store ID',
    showOriginatingStoreIdTooltip:
      'Shows the source store ID on orders for fulfillment houses with several stores.',
    enableMultiShipment: 'Enable multi-shipment',
    enableMultiShipmentTooltip:
      'Lets one order ship as several shipments, each with its own label.',
    enableReprintOption: 'Enable reprint option',
    enableReprintOptionTooltip:
      'Lets workers reprint labels or packing slips within a set time window.',
    useShipStationV2Api: 'Use ShipStation V2 API',
    useShipStationV2ApiTooltip:
      "Switches this tenant to ShipStation's newer V2 API. Imports don't use it yet.",
    logglyShipworksImport: 'Loggly ShipWorks import',
    logglyShipworksImportTooltip:
      'Logs ShipWorks order responses to Loggly for debugging and monitoring.',
    logglyShopifyImport: 'Loggly Shopify import',
    logglyShopifyImportTooltip:
      'Logs Shopify order responses to Loggly for debugging and monitoring.',
    logglyGpxPrintingLabel: 'Loggly GPX label printing',
    logglyGpxPrintingLabelTooltip: 'Logs GPX label printing events to Loggly.',
    logglyShippingEasyImport: 'Loggly ShippingEasy import',
    logglyShippingEasyImportTooltip:
      'Logs ShippingEasy order responses to Loggly.',
    logglyShipStationImport: 'Loggly ShipStation import',
    logglyShipStationImportTooltip:
      'Logs ShipStation order responses to Loggly.',
    logglyVeeqoImport: 'Loggly Veeqo import',
    logglyVeeqoImportTooltip: 'Logs Veeqo order responses to Loggly.',
    logglyGpxOrderScan: 'Loggly GPX order scan',
    logglyGpxOrderScanTooltip: 'Logs GPX order scan events to Loggly.',
    logglyGpScannedTag: 'Loggly GP scanned tag',
    logglyGpScannedTagTooltip:
      'Logs GroovePacker scanned-tag events to Loggly.',
    logglyProductInventoryTrack: 'Loggly product inventory tracking',
    logglyProductInventoryTrackTooltip:
      'Logs product inventory tracking events to Loggly.',
    inventoryPushBigCommerce: 'BigCommerce',
    inventoryPushBigCommerceTooltip:
      'Pushes inventory quantities to BigCommerce automatically.',
    inventoryPushShopify: 'Shopify',
    inventoryPushShopifyTooltip:
      'Pushes inventory quantities to Shopify automatically.',
    inventoryPushShopline: 'Shopline',
    inventoryPushShoplineTooltip:
      'Pushes inventory quantities to Shopline automatically.',
    inventoryPushMagento2: 'Magento 2',
    inventoryPushMagento2Tooltip:
      'Pushes inventory quantities to Magento 2 automatically.',
    inventoryPushTeapplix: 'Teapplix',
    inventoryPushTeapplixTooltip:
      'Pushes inventory quantities to Teapplix automatically.',
    regularUsers: 'Regular users',
    regularUsersTooltip:
      "The most regular users this tenant can have. Regular users pack and scan, and both active and inactive users count toward this limit, but deleted users don't.",
    adminOnlyUsers: 'Admin-only users',
    adminOnlyUsersTooltip:
      "The most admin-only users this tenant can have. These users sign in to manage the account but don't pack, and they're counted separately from regular users.",
    shipmentsPerMonth: 'Shipments per month',
    shipmentsPerMonthTooltip: 'Shipments included in the plan each month.',
    deleteOrdersAfterDays: 'Delete orders after (days)',
    deleteOrdersAfterDaysTooltip:
      'Orders older than this many days are deleted automatically.'
  },
  recordTracingmsg: {
    createShippingLabel:
      'Please create the shipping label, adhere it to the package, and scan the tracking number to continue.'
  },
  shippinglabelmsg: {
    scanShippingLabel: 'Please scan the shipping label barcode to continue.',
    noRecordTracking:
      'This order does not have a tracking number associated with it. It may have been imported before the shipping label was generated. Please click or press Enter to bypass this check and mark the order scanned.'
  },
  orderConfirmationPopup: {
    orderConfirmationMismatch:
      "This confirmation code does not appear to valid. Confitmation codes can be updated on the user's page in the setting section.",
    orderConfirmationText: 'Confirmation is required for this note:',
    orderConfimationEnterScan:
      'Enter or scan your confirmation code to continue.',
    orderConfirmationTextBedoreInput:
      'Please confirm you saw the note by entering your confirmation code.'
  },
  productConfirmationPopup: {
    productConfirmationTest:
      'Please confirm the following product instructions were followed by entering your confirmation code.',
    productConfirmationEnterScan:
      'Enter or scan your confirmation code to continue',
    productConfirmationAlert:
      "This confirmation code does not appear to valid. Confitmation codes can be updated on the user's page in the setting section.",
    inputPlaceHolder: 'Enter Confirmation Code to Continue',
    productInstruction: 'Product Instruction for'
  },
  serialRecord: {
    serial_number: 'Scan or Enter Serial, Lot or Batch Number',
    serial_number_two: 'Scan or Enter Serial, Lot or Batch Number 2'
  },
  wmsLotVerification: {
    confirmationCodeMessage:
      'Scan or enter your confirmation code to verify this lot',
    lotNumberMessage: 'Scan or enter the lot number: {{lot}}',
    confirmationCodeError: 'That confirmation code was not recognised.',
    lotNumberError:
      'That is not the lot number for this item. Scan or enter the lot shown.'
  },
  wmsZeroInventory: {
    authorizedByMessage: '{{message}} (Authorized by: {{authorizedBy}})',
    lotRequiredError: 'Enter a lot/batch number.',
    qtyRequiredError: 'Enter a quantity of at least 1.',
    passButton: 'Pass'
  },
  copiedText: {
    copiedCartId: 'Cart ID "{{cartId}}" copied to clipboard!',
    copiedToteId: 'Tote "{{toteId}}" copied to clipboard!'
  },
  scanPack: {
    settingUpdateFailed: 'Unable to update setting. Please try again.',
    already_scanned: 'The order has already been scanned.',
    already_cancelled: 'This order has been canceled and can not be scanned.',
    permissionDeniedTitle: 'Permission Denied',
    permissionDeniedMessage:
      'Administrative users don’t have permission to scan orders.',
    scanned_one_pass: ' The order has been marked scanned.',
    packing_slip: 'Scan a Packing Slip',
    shippingLable_or_packingSlip: 'Scan a Packing Slip or Shipping Label',
    shippingLable: 'Scan a Shipping Label',
    assignOrderTooltip:
      'Clicking the Assign Orders button will assign orders to the user who clicked it. Orders will be assigned from the Priority list in order of highest priority, as determined by your settings. The number of orders assigned is determined by the setting on the button.',
    empty_order:
      'No items were found in this order. If this is not expected please try removing and reimporting the order. If this issue continues please contact support.',
    quickScanTollTip: `Click the Quick-Scan button or scan a barcode with the
                      value QUICKSCAN to automatically display the oldest
                      unscanned order for verification.`,
    noOrderPresent: `No orders were found in the awaiting orders list.`,
    alreadyScanned: `This order has already been scanned`,
    howToProceed: `How would you like to proceed`,
    rePrint: `Re-Print Shipping Label`,
    reScan: `Re-Scan This Order`,
    alreadyScannedMessage: `Order {{orderNumber}} has already been scanned.`,
    inputPlaceHolder: 'Ready for Order Scan',
    scanLabel: 'Scan',
    quickScanLabel: 'Quick-Scan',
    importLabel: 'Import Now',
    importStatusLabel: 'Check Import Status',
    rfoTitle: `Scan the Packing Slip of an Order you'd like to Pack.`,
    awaitingOrdersRemaining: 'Awaiting Orders',
    scannedOrder: 'Scanned Today',
    checkInternet: 'Please check your internet connection',
    onDemandRequested:
      "We are requesting that order and it will open as soon as it's available. If you do not wish to wait you can scan another order number.",
    onDemandCancel: 'Cancel',
    importStatus: {
      status: 'Import Status',
      last: 'Last',
      current: 'Current',
      processed: 'Orders Processed',
      remaining: 'Orders Remaining',
      elapsedTime: 'Elapsed Time',
      timeRemaining: 'Time Remaining',
      lastImport: 'Last import completed'
    },
    shouldInventoryAdjust: 'Should inventory be adjusted?',
    noReScanItems: 'No, the previous items are being re-scanned',
    yesPullInventory: 'Yes, new items were pulled from inventory',
    noDataAvailable: 'No data available',
    lastImportLabel: 'The last import was',
    importStartedLabel: 'The last import was started',
    ago: 'ago',
    estimatedTime: 'Estimated time remaining',
    hoursForStore: 'seconds for store',
    minutesForStore: 'minutes for store',
    secondsForStore: 'seconds for store',
    calculateEstimate: 'Estimated time remaining calculating',
    hours: 'hours',
    minutes: 'minutes',
    headerLabel: 'Scan & Verify'
  },
  product: {
    images_remove:
      'Are you sure you want to remove this image from the product?',
    alias_of_another: 'Make this product an alias of another',
    aliases_of_this_product: 'Choose products that are aliases of this product',
    kit_to_product: 'Change this kit back to a product',
    product_to_kit: 'Change this product to a kit',
    product_not_found: 'Product cannot be found with sku',
    same_barcode_found: 'Oh shizzle, that barcode already exists!',
    same_sku_found: 'Oh shizzle, that SKU already exists!',
    QOH: 'QOH',
    location1: 'Location 1',
    location2: 'Location 2',
    location3: 'Location 3',
    location_qty1: 'Location 1 Qty',
    location_qty2: 'Location 2 Qty',
    location_qty3: 'Location 3 Qty',
    inventory_alert_level: 'Inventory Alert Level',
    inventory_target_level: 'Inventory Target Level',
    product_name: 'Product Name',
    skus: 'SKUs',
    barcodes: 'Barcodes',
    unique_bar: 'Scan or Enter a unique Barcode',
    unique_sku: 'Scan or Enter a unique SKU',
    scan_qty: 'Scan Qty',
    categories: 'Categories',
    fnsku: 'FNSKU',
    asin: 'ASIN',
    isbn: 'ISBN',
    ean: 'EAN',
    supplier_sku: 'Supplier SKU',
    avg_cost: 'AVG Cost',
    count_group: 'Count Group',
    product_weight: 'Product Weight',
    product_length: 'Product Length',
    product_width: 'Product Width',
    product_height: 'Product Height',
    product_dimension_unit: 'Product Dimension Units',
    // scan & pack option text
    click_scan: 'Pass / click-scan',
    type_count: 'Type-In Count',
    record_serial: 'Record Serial / Lot / Batch',
    record_type_label_1: 'Value 1:',
    record_type_label_2: 'Value 2:',
    record_type_serial: 'Serial',
    record_type_lot: 'Lot/Batch',
    intangible_item: 'Intangible Item',
    add_any_order: 'Add to any order',
    optional_item: 'Optional Item / skippable',
    packing_ins: 'Packing Instructions',
    require_conf: 'Require Confirmation',
    scanning_seq: 'Scanning Sequence Override',
    custom_prod1: 'Custom Product 1',
    custom_prod2: 'Custom Product 2',
    custom_prod3: 'Custom Product 3',
    display: 'Display',
    aliasOfAnotherMessage: 'Are you sure? This can not be undone!',
    click_scan_tooltip:
      'Items with missing or damaged barcodes can be Passed using the Pass button when enabled. The option can be disabled for items that should never be passed. "With Confirmation" will require a user with "Pass Button" permission to provide their confirmation code. "With Message" will permit Passing but a message will be shown which discourages unnecessary use.',
    type_count_tooltip:
      "When enabled, this setting allows you to scan one of an item and then manually type in a quantity rather than scanning each item one by one. It's ideal when you have many items that are pre-counted in cases. You can set the type-in trigger in the Scan and Pack settings.",
    record_serial_tooltip:
      'When enabled, the packer will be prompted to scan a serial number each time this product is packed. The recorded serial can then be viewed in the Order Activity log or downloaded in the Order Serial CSV. One or two entries can be recorded based on the setting.',
    intangible_item_tooltip:
      "Intangible items, also known as transactional items, are non-physical items that do not need to be packed. Examples are Coupon Codes, Insurance, Same day handling charges etc. Many times these items import along with regular order items. To avoid having these items prompted during Scan and Pack you can enable this option to designate them as intangible.If you have intangible items that are dynamically generated but always contain a specific string you can have GroovePacker automatically set these items to intangible. You'll find this option in the Scan and Pack settings.",
    add_any_order_tooltip:
      "When this option is enabled for a product you can add it to any order you're packing just by scanning it. This is great for tracking the inventory of boxes or bags that are decided on at the time of packing. Catalogs, coupons, freebie items can be scanned and tracked too. Items added will be saved with the order record in GroovePacker and included on packing slips printed after packing is complete.",
    optional_item_tooltip:
      'Unlike the commonly used "Pass" option the Skippable option is usually enabled only for non-essential items, like free-bees or coupon cards which are normally scanned but which can be skipped when stock is out. The SKIP action barcdoe is scanned to skip an item. Skipped items may be removed from the order or may remain depending on the global setting found in the Scan and Pack options with the SKIP action barcode.',
    packing_ins_tooltip:
      'The packing instructions text here will be shown every time this item is suggested for scanning. In addition to adding instructions here they can also be imported in bulk using the CSV product importer. Enabling the Confirmation Required switch will prompt the user to scan or enter their assigned confirmation code to confirm they have seen the product instructions',
    scanning_seq_tooltip:
      'The suggested scanning sequence is determined automatically. Items are sorted alphabetically by the Primary bin location. If no primary location is saved the SKU will be used to sort the items. If you wish to Override this sorting sequence and force some items to display before or after other items this setting can be used. ie. If the item should be picked or scanned before all others, or after all others you can adjust this value. By default, all items have a value of 50. Items with override values closer to 1 will be sorted before those with values closer to 99 regardless of the SKU or Location saved. The override value can also be set in bulk using a CSV file.',
    custom_prod1_tooltip:
      'Custom product data can be entered here or imported using the product CSV importer. Each field can optionally be displayed when the item is suggested for scanning. The is very useful when variant information like size or color is not easily readable in the SKU or product name but is required by the picker or packer.',
    scanRecordCountText:
      'Confirmation is required for this action.\nPlease scan or enter your confirmation code to continue.',
    scanRecordErrorText:
      'The confirmation code provided is not valid. Please try again',
    zeroBarcodeText:
      '”New” items will automatically change to “Active” items when their barcode is added. It’s not possible to manually change the status from “New” to “Active”. In the case of Kits, each kit will need to have active part items as well as a barcode to be active.',
    address_new_items: 'How to address "New" items',
    // Kit options text
    kit_scanning: 'Kit Scanning Options',
    alertBoxMultiBox:
      'Please scan items into the current box before creating another box.',
    alertBoxChampPlanned:
      'This order is BoxChamp-planned. Boxes are added automatically as items are packed.',
    alertBoxEmptyBoxPrint:
      'Please scan items into the box before printing a packing slip.',
    alertPrintSlipFailed: 'Packing slip did not print. Try again.',
    alertBoxPermission:
      'Please contact a team member and request edit permissions before making changes.',
    alertBoxOrderInProgress:
      'Cannot update. The order is currently assigned to a cart and in progress.',
    alertBoxSaveData: 'product data has been updated',
    scanToCartEditRestriction:
      'Product updates are disabled when opened from Scan to Cart.',
    status: 'Status',
    prePackedKitItem: 'Pre-packed kits are scanned as one item',
    oneBarcodeKitItem: `- One barcode is scanned which represents the all kit items. This permits inventory tracking for the kit parts.`,
    kitParts: 'Kit parts items are each scanned individually',
    singleKitItem: `- The barcodes of the individual items in the kit are always scanned.`,
    singleKitBarcode: `- A single kit barcdoe is scanned unless prepacked kits are unavailable and kit part are barcodes will need to be scanned.`,
    kitPrePacked: `Kits are usually Pre-packed`,
    pickerSelectedOptions: {
      one: `1 - Pre-Packed Kits Are Scanned as One item`,
      two: `2 - Kit Part items are each scanned individually`,
      three: `3 - Kits are usually Pre-packed`
    }
  },
  directprinting: {
    printPackingSlip: 'Print Packing Slip',
    printingPackingSlip: 'Printing packing slip…',
    soundSettings: 'Sound Setting',
    soundSettingLabel: 'Sound Setting',
    saveLabel: 'Save',
    enterNumberOfSeconds: 'Number of seconds',
    slideShow: 'Slide Show Time',
    selectSound: 'Sound Upload',
    selectSoundSetting: 'Select Sound Setting', // English translation for sound settings
    enableCorrectScanFeedback: 'Enable Correct Scan Feedback',
    errorScanFeedback: 'Error Scan Feedback',
    orderDoneFeedback: 'Order Done Feedback',
    default: 'Default',
    selectprinter:
      'Please choose the printer that you would like to use for jobs of this type.',
    directprintingHead: 'Direct Printing Settings',
    otherOptions: 'Other Options',
    packingslipSetting: 'Packing Slips & Print Jobs',
    productBarcode: 'Order Number Barcode',
    shippiglabel: 'Shipping Labels via API',
    ordernumberbarcode: 'Product Barcode Labels',
    hapticsLable: 'Haptic Feedback',
    suppressSoftwareKeyboard: 'Suppress Software Keyboard',
    suppressSoftwareKeyboardTooltip:
      'When enabled, the on-screen keyboard will not appear when the scan field is focused. Use this with an external Bluetooth or USB barcode scanner so the scanning interface stays visible. Turn this off if you need to type barcodes manually.',
    receiveRecountLabel: 'Product Receiving Labels',
    alertForPdfSizeEdit:
      'Input is not editable on GPX. You can edit the Pdf size from legacy app',
    packingsliptolltipOne:
      'Direct printing uses an app installed on your Mac or PC to send print jobs directly to your printer instead of opening them in a browser tab.',
    packingsliptolltipLinkText: 'This knowledge base article',
    printerSizeSelectionText:
      'Please select the print size and then choose a file.',
    packingsliptolltipTwo:
      ' explains in detail. Each user can set a printer for each job type that will be used when they print. The Reset button can be used to clear all printer associations.',
    productbarcodetolltip:
      'Product barcode labels can be printed from a number of areas in the GPX app. When enabled they will be sent directly to the printer.',
    shippinglabeltolltip:
      'GroovePacker and generate shipping labels using the Label API of some order managers. When enabled these labels will be sent directly to the printer.',
    ordernumbertolltip:
      'A smalll label containing just the customer’s name and order number can be printed automatically after each order is scanned. When enabled this label will be sent directly to the printer. ',
    tooltippacking:
      ' Packing slips can be printed manually or automatically. Enable this switch to have packing slips sent directly to the printer.',
    tooltipBarcode:
      'Product barcode labels can be printed from a number of areas in the GPX app. When enabled they will be sent directly to the printer.',
    tooltipShipping:
      'GroovePacker can generate shipping labels using the Label API of some order managers. When enabled these labels will be sent directly to the printer.',
    tooltipOrderBarcode:
      'A smalll label containing just the customer’s name and order number can be printed automatically after each order is scanned. When enabled this label will be sent directly to the printer. ',
    tooltipHaptics:
      'When enabled, Android devices will vibrate to confirm scans and some operations.',
    tooltipDirectPrintinHeading:
      'Direct printing uses an app installed on your Mac or PC to send print jobs directly to your printer instead of opening them in a browser tab. This knowledge base article explains in detail. Each user can set a printer for each job type that will be used when they print. The Reset button can be used to clear all printer associations.',
    tooltipSoundSetting:
      'Select any type and upload the file to which you want to add sound.',
    tooltipReceivingPrinting:
      'Product receiving labels are used to label boxes of extra stock so they can be easily identified and scanned. This switch enables the direct print option for these labels',
    tooltipPushInventory:
      'Push Inventory lets you send inventory updates directly to your Shopify store during a recount or when receiving inventory reports.',
    tooltipWeights:
      'You can enter weights in ether Metric or English units. For English, the weight can be entered using a combination of Pounds and Ounces or just Ounces. For Metric, the weight can be entered using a combination of Kilograms and Grams or just Grams.',
    tooltipResidential:
      'UPS requires that a shipment be designated Residential if it is shipped to a residential address or Commercial if it is shipped to a commercial address.',
    alertForPdfLimit:
      'You have reached the daily limit of file picks. Or file size exceed 40MB',
    alertForNoPrinter:
      'No printers available. To print from the browser please disable direct print.',
    confirmAgainPrinting:
      'Are you sure? \n It looks like this file may have already been printed.',
    pdfMovedNotification:
      'After printing, the PDF will be moved to the printed tab.',
    // printComplete:"File print using QZ",
    selectLanguage: 'Select Language',
    english: 'English',
    spanish: 'Spanish'
  },
  clearFilterPrompt: {
    clearFiltersText: 'No Order in the current view matches your search.',
    clearFiltersBtnText:
      'Click here to clear filters and expand your search to all orders in GroovePacker.'
  },
  filters: {
    include: 'Include',
    exclude: 'Do not include',
    all: 'All',
    any: 'Any'
  },
  packingCamDetail: {
    enterEmail:
      'Please add an email address below to enable the packing cam options.',
    placeholder: 'Enter Email Address',
    emailSentPopup: 'Email sent Successfully',
    failToUpload: 'Failed to upload image, try again',
    uploadComplete: 'Upload complete',
    uploading: 'Uploading...',
    escTollTip: 'ESC to Cancel',
    spaceBarTollTip: 'SPACEBAR to Retake',
    enterTollTip: 'ENTER to Confirm',
    cancelLabel: 'Cancel',
    retakeLabel: 'Retake',
    confirmLabel: 'Confirm'
  },
  reprintText: {
    reprintNotAllowHeading:
      'They were purchased in the order manager and would need to be reprinted there.',
    previousPurchaseLabelHeading: 'Previously purchased labels found',
    canBeReprintHeading: 'Previously printed labels can be reprinted below',
    canBeReprintSubHead: 'Click a label to reprint it.'
  },
  order: {
    internal_notes: 'Internal Notes',
    notes_to_packer: 'Notes to Packer',
    customer_comments: 'Customer Comments',
    tags: 'Tags',
    notes_from_packer: 'Notes from Packer',
    internal_notes_tooltip:
      'Internal notes can be imported from the order source. For example if you add a note to an order in ShipStation or ShippingEasy it can be imported and saved in this field. The import of internal notes  is controlled in the settings for each store. Once imported, an option in the scan and pack setting determines if the note will be shown to the packer.',
    notes_to_packer_tooltip:
      'If notes to the packer are being added in GroovePacker directly this field should be used. Anything saved here is always shown during scanning.',
    customer_comments_tooltip:
      'With some integrations customer comments can be imported into this field and optionally displayed during scanning. Once imported, an option in the scan and pack settings determines if the customer comments will be shown to the packer.',
    tags_tooltip:
      'Shopify order tags can be imported into this field and optionally displayed during scanning. Once imported, an option in the scan and pack settings determines if the tags will be shown to the packer.',
    notes_from_packer_tooltip:
      'A note added to the order during the scanning process will be displayed here. The note can be automatically emailed to the notifications address specified in the system settings as well. The note can be added during scanning by using the "Add Note" button or by scanning the action barcode: NOTE This barcode can be printed from the Scan and Pack settings section.',
    order_number: 'Order Number',
    scanning_completed: 'Scanning Completed',
    order_date: 'Order Date',
    tracking_number: 'Tracking Number',
    customer_order_data1: 'Customer Order Data 1',
    customer_order_data2: 'Customer Order Data 2',
    first_name: 'First Name',
    last_name: 'Last Name',
    email: 'Email',
    company: 'Company',
    city: 'City',
    state: 'State',
    address_1: 'Address 1',
    address_2: 'Address 2',
    postal_code: 'Postal Code',
    country: 'Country',
    addKitToKitMessage:
      'Would you like to add the kit part items from kit {{childKit}} as part items under {{parentKit}}',
    kitItemTolltip:
      'Search for the kit part items you would like to add by entering the name or sku or by scanning the barcode. Click an item to select it. Multiple searches and selections can be made before saving so you can add multiple items at the same time.',
    inventoryKitTollTip:
      'Pre-packed kits are scanned as one item - One barcode is scanned which represents the all kit items. This permits inventory tracking for the kit parts.Kit parts items are each scanned individually - The barcodes of the individual items in the kit are always scanned.Kits are usually Pre-packed - A single kit barcdoe is scanned unless prepacked kits are unavailable and kit part are barcodes will need to be scanned.',
    productSearchListTooltip:
      'Scan or enter the barcode of an item to open it directly. Searching with the exact SKU will also open the item directly. Partial matches will be shown in a list.',
    addItemToOrderError:
      'Please change the status of this product/kit to Active before adding it to the order.',
    addItemToOrderTollTip:
      "Multiple items can be added to an order at once. After searching for an item by it's name, sku or barcode use the checkbox to select it. Additional selections can be made the same way. Once all required items are selected click 'Save & Close' to add them to the order.",
    multiBoxTollTip:
      'The dropdown allows you to select whether the packing slip will be printed for the currently selected box(in the table below) or if packing slips for all boxes will be printed. Click the printer icon to initiate printing.',
    orderNotFound:
      'The order number provided was not found. The corresponding order may not have been imported yet.',
    selectedUserError:
      'Please select multiple orders for the  assigning or removing.',
    noSelectedUserError:
      'Please select orders or users for assigning or removing.',
    cartPreviewFailed:
      'Could not check whether these orders are on a cart. The status was not changed.',
    cartRemovalTitle: 'Are you sure?',
    cartRemovalConfirm: 'Change status',
    cartRemovalCancel: 'Cancel',
    cartRemovalSingleOrder:
      'This order is on cart {{cart}}. Changing its status removes it from the cart. The other orders stay on the cart.',
    cartRemovalSingleOrderNoLabel:
      'This order is on a cart. Changing its status removes it from the cart. The other orders stay on the cart.',
    cartRemovalOneOrder: '1 of these orders is on a cart and will be removed from it.',
    cartRemovalManyOrders:
      '{{count}} of these orders are on carts and will be removed from them.',
    statusUpdateFailed: 'Failed to update the order status. Please try again.',
    quantityUpdateFailed: 'Failed to update the item quantity. Please try again.',
    clearAllAssignmentLabel: 'Clear All Assignments',
    clearAllAssignmentMessage:
      'Are you sure you want to clear all assignments?',
    createOrder: 'Create Order',
    cameraPermissionMessage:
      'Packing cam needs camera access. Please enable the browser webcam permissions, then click retry below. If the packing cam will not be used at this workstation please disable it by clicking disable below.',
    disableButton: 'Disable',
    retryButton: 'Retry'
  },
  tagPriority: {
    createPriorityCardText:
      'Orders with this priority will be identified by the following tag:'
  },
  awaitingWindow: {
    title: 'Awaiting Order Window',
    daysLabel: 'Days',
    tooltip:
      'The date filtering window set here is used for the default order list filtering view. It does not affect order assignment — orders of any age remain eligible to be assigned to users.',
    saveButton: 'Save & Close',
    invalidDaysError: 'Please enter a valid number of days greater than 0',
    saveError: 'Failed to save the setting. Please try again.'
  },
  activityException: {
    alerts: {
      exceptionRecorded: 'Exception Successfully Recorded',
      exceptionMissingReason: 'Cannot record exception without reason',
      exceptionCleared: 'Record exception cleared',
      noExceptionToClear: 'Order does not have exception to clear'
    },
    headers: {
      activityLog: 'Activity Log',
      packingExceptions: 'Packing Exceptions',
      exceptionType: 'Exception Type',
      description: 'Description',
      associatedWith: 'Associated exception with'
    },
    buttons: {
      saveAsText: 'Save as Text',
      recordException: 'Record Exception',
      clearException: 'Clear Exception'
    }
  },
  addItemInBox: {
    addItemsTollTip: `Multiple items can be added to an order at once. After searching
              for an item by it's name, sku or barcode use the checkbox to
              select it. Additional selections can be made the same way. Once
              all required items are selected click "Save & Close" to add them
              to the order.`
  },
  shipmentRecord: {
    additionalShipments: 'Additional shipments Associated With this order',
    shipmentWarning:
      'One of the shipments associated with this order was scanned in GroovePacker and then combined in ShippingEasy. Rather than modifying an order that has been scanned we are letting you know so you can take any action that is required',
    acknowledgeAndContinue:
      'Once all unwanted shipments are removed you can click here to acknowledge and continue.'
  },
  productFirst: {
    claimHeading: 'Please scan one of your {{toteIdentifier}}(s) to begin.',
    claimPlaceholder: 'Scan a {{toteIdentifier}} Barcode',
    scanProductPlaceholder: 'Scan a Product Barcode',
    scanTotePlaceholder: 'Please Enter or Scan {{toteIdentifier}} Barcode',
    scanProductPrompt: 'Scan a product to begin.',
    orderAssigned:
      'Order {{orderNumber}} is assigned to {{toteIdentifier}} {{toteName}}',
    unscannedTitle: '{{count}} Unscanned Items',
    itemsInToteTitle: '{{count}} Items in {{toteIdentifier}}',
    bannerScan: 'Scan {{toteIdentifier}} {{toteName}}',
    bannerPlaceEmpty: 'Please place in {{toteIdentifier}} {{toteName}}',
    bannerPlaceOccupied:
      'Please place in occupied {{toteIdentifier}} {{toteName}}',
    bannerCollect:
      'Scan & collect {{toteIdentifier}} {{toteName}} to finalize the order.',
    orderComplete: 'Order Complete!',
    stateEmpty: 'Empty',
    stateOccupied: 'Occupied',
    stateCollect: 'Collect',
    invalidTote: 'Please scan a valid {{toteIdentifier}} barcode.',
    wrongTote:
      'Whoops! That’s the wrong {{toteIdentifier}}. Please scan the correct {{toteIdentifier}} and then add the item to it.',
    scanFailed: 'Scan failed. Please try again.',
    restartOrder: 'Restart Order',
    removeItem: 'Remove Item',
    removeFirst: 'Remove',
    removeSecond: 'Item',
    addNote: 'Add Note',
    restartConfirm:
      'Restart this order? Its {{toteIdentifier}} assignment will be cleared.',
    removeConfirm: 'Remove this item from the order?',
    addNotePlaceholder: 'Enter a note for this order',
    toteSetButton: '{{toteIdentifier}} Set {{name}}',
    switchToteSet: 'Switch {{toteIdentifier}} Set',
    progressPlaced: '{{count}} of {{total}} items scanned & placed',
    progressLeftHint: 'Items shown on the left complete this order.',
    scanToContinue: 'Scan any available product to continue.'
  },
  scanToCart: {
    barcodeAssignedToOtherProduct:
      'This barcode is already assigned to another product.',
    addBarcodeFailed: 'The barcode could not be saved. Please try again.',
    toteFullScanNext: 'This item is already in its tote. Scan the next item shown.',
    toteFullNoOtherLine: 'This item is already in its tote and cannot be scanned again. Restart the cart or ask a supervisor.',
    tollTip: `If orders need to be assigned to a specific tote, they can be tagged with that tote's tote ID. eg. Tagging an order with "A-1-C01" will assign it to the first tote on row A of cart 1.Click a tote below to copy its tote ID tag to your clipboard.`,
    tollTipLabel: `Orders Tagged "{{cartId}}" will only be assigned to this cart.`,
    addRowLabel: `Add a Row`,
    addCartLabel: `Add a Cart`,
    cartsLabel: 'Carts',
    printToteLabel: 'Print Tote Labels',
    rowIdLabel: 'Row ID',
    totesInRowLabel: 'Totes/Row',
    dimensions: 'Dimensions',
    saveChanges: 'Save Changes..',
    duplicateRow: 'Duplicate Row',
    duplicateCart: 'Duplicate Cart',
    saveChanges: 'Save Changes..',
    okButtonLabel: 'Ok',
    cartUpdateError: 'This cart is currently in use by active orders and cannot be updated or deleted.',
    cartAssignedOrders: 'This cart has %{count} order(s) assigned, so it cannot be updated or deleted. Reset the cart to remove them.',
    cartResetConfirm: 'Resetting removes these orders from the cart and undoes their picking progress. Continue?',
    cartResetFailed: 'Could not reset the cart. Please try again.',
    resetCartButton: 'Reset Cart',
    cancelLabel: 'Cancel',
    scanningCompleted: 'Cart scanning completed',
    ConfirmReset: 'Yes, Restart',
    CancelReset: 'No, Cancel',
    includeActionRequiredOrders: 'Include Action Required Orders',
    includeActionRequiredOrdersTooltip:
      'When enabled orders containing "New" items (items without barcodes) will be included in batches. If pickers are permitted to add barcodes for new items during the scanning process this switch should be on. If you would prefer to hold orders and require an admin to add product barcodes the switch should remain off.'
  },
  cartAssignment: {
    title:
      'This cart currently has orders assigned. How would you like to continue?',
    continueButton: 'Continue picking these orders',
    continueProcessingButton: 'Continue processing these orders',
    restartButton: 'Restart the orders & Clear the cart',
    cancelButton: 'Cancel and use another cart',
    previouslyScanned: 'This order was previously scanned.',
    previouslyScannedDetails: 'Scanned by {{username}} on {{timestamp}}',
    cartReadyForProcessing:
      '{{cartName}} ready for processing. Scan any of the occupied totes below to continue.',
    continueTooltip:
      'Take assignment of these orders and continue scanning them. Progress will be maintained. This is a good option if the user picking this cart is handing it off to you to finish the pick.',
    restartTooltip:
      'All progress on these orders will be lost. This option will Restart and un-assign all orders on this cart for a fresh start.\n\nBe sure to physically empty all totes on the cart if you choose this option.\n\nOrders will be re-assigned from the priority list. This is a good option if you are unsure of the status of the orders in the cart and would rather start a fresh pick rather than continuing this one.',
    cancelTooltip:
      'Choose "Cancel" to leave this cart as is. You can then scan a different cart to continue. This is a good option if the user assigned to this cart will resume picking it later.',
    processNowButton: 'Process the order in this tote now',
    processNowTooltip:
      'Normally orders are processed after the full pick is complete. If you scan the tote of an order that is fully picked on a partially picked cart you can use this option to jump to the processing step of that particular order.',
    mixedResults:
      '{{failedCount}} Orders could not be assigned - {{successCount}} Orders successfully assigned to {{cartId}}.',
    failedOnly: '{{failedCount}} Orders could not be assigned.',
    successOnly: '{{successCount}} Orders successfully assigned to {{cartId}}.',
    viewDetails: 'View Details',
    noOrders: 'No available orders found.',
    rfoNoOrders: 'No orders available for assignment.',
    clickHere: 'Click Here',
    toRunImport: 'to run an import.',
    awaitingOrders: 'Awaiting orders from the last {{days}} Days: {{count}}',
    closeToast: 'Close',
    assignedToOthers: 'Orders Assigned to other users: {{count}}',
    taggedForOtherCart: 'Orders Tagged for another cart: {{count}}',
    availableForCart: 'Orders available for this cart: {{count}}',
    excludedByZone: '{{count}} orders excluded by zone access',
    emptyTotes: '{{count}} empty totes available',
    issueDetails: {
      title: 'Issue Details',
      noIssues: 'No issues preventing assignment.',
      successTitle: 'Details of Successful tote assignments.',
      closeButton: 'Close and Continue'
    }
  },
  resumePicking: {
    title: `Would you like to resume picking cart {{cartNumber}}?`,
    continueButton: 'Yes, continue the pick in progress',
    clearButton: 'No, Clear this cart & start again',
    confirmationTitle:
      'Please verify all totes are empty before continuing. This will reset all orders assigned to the cart.',
    cancelButton: 'Cancel',
    confirmButton: 'Confirm'
  },
  returnLater: {
    title: 'Would you like to return to this item later?',
    yesButton: 'Yes, return to it later',
    noButton: 'No, skip this item permanently'
  },
  stockIssue: {
    title: 'Report Stock Issue',
    replenishButton: 'Request location be replenished',
    replenishTooltip:
      'Send a request for this location to be restocked. You can continue picking other items.',
    holdOrdersButton: 'Hold orders due to out of stock',
    holdOrdersTooltip:
      'Mark this item as out of stock and set its order aside. Other orders on the cart continue.',
    cancelButton: 'Cancel'
  },
  notFulfilledItems: {
    title: 'The following items could not be fulfilled:',
    scanButton: 'Scan the not-fulfilled item(s) now',
    scanTooltip:
      'Not fulfilled item was found in the warehouse and orders can now be fully processed',
    removeButton: 'Remove the not-fulfilled item',
    removeTooltip:
      'Not fulfilled items will be cancelled/refunded, other items will still ship. Manager/customer will be notified',
    serviceButton: 'Leave as Service Issue',
    serviceTooltip: 'Order will be marked for later processing by service team',
    cancelButton: 'Cancel',
    putAwayButton: 'Put items away',
    putAwayTooltip:
      'Return the picked items to their locations. The whole order will be picked again later.',
    storeButton: 'Store picked items',
    storeTooltip:
      'Keep the picked items together and set them aside. When stock arrives, only the missing item needs to be scanned.',
    backButton: 'Back',
    holdFailed:
      'Could not leave the order as a Service Issue. Please try again.',
    backorderButton: 'Backorder',
    backorderTooltip:
      'This item will be backordered and ship later, but the other items in the order are still shipping today.',
    backorderFailed: 'Could not backorder the item. Please try again.'
  },
  assignOrder: {
    assign: 'Assign',
    orders: 'Orders',
    successMessage: 'orders successfully assigned.',
    notAssignedMessage:
      'It appears there are no unassigned, awaiting orders from the last 14 days.'
  },
  dashboard: {
    eachUserItemsByToday: `Total items scanned today.`,
    eachUserOrdersByToday: `Total orders scanned today.`,
    eachUserItemsForToDay: `Each user's items/min for today`,
    eachUserOrdersForToDay: `Each user's orders/min for today`,
    eachUserItemsByDay: `Items per day over 6 days`,
    eachUserOrdersByDay: `Orders per day over 6 days`,
    itemsScannedByTime: `Items/min Yesterday vs Today`,
    ordersScannedByTime: `Orders/min Yesterday vs Today`,
    current15MinSession: `Total items by user - Current 15 min session`,
    current15MinSessionOrders: `Total orders by user - Current 15 min session`,
    itemsPerMinute: `Items Per Minute (6 Days)`,
    ordersPerMinute: `Orders Per Minute (6 Days)`,
    itemsPerHour: `Items Per Hour`,
    ordersPerHour: `Orders Per Hour`,
    scanScoreToday: `Today's High Scores`,
    dailyOrderGoal: `Daily Order Goal`,
    goalCompleted: `Completed`,
    goalRemaining: `Remaining`,
    goalMet: `Goal Met`,
    shiftDone: `Shift Done`,
    goalLabel: `Goal`,
    fullShift: `Full Shift`,
    shiftWorked: `Worked`,
    shiftStart: `Start`,
    shiftEnd: `End`,
    goalNoData: `No data available`,
    setProductionGoal: `Set Today's Production Goal`,
    updateProductionGoal: `Update Daily Production Goal`,
    updateGoalButton: `Update Goal`,
    goalSave: `Save`,
    goalCancel: `Cancel`
  },
  verbosity: {
    noAnnouncement: 'No Announcements',
    locationOnly: 'Location Only',
    locationAndQuantity: 'Location & Quantity',
    skuLocationAndQuantity: 'SKU, Location & Quantity',
    locationAndTotalQuantity: 'Location & Total Quantity',
    skuLocationAndTotalQuantity: 'SKU, Location & Total Quantity',
    tollTip:
      'Voice picking can announce the information that helps with the pick pack process so you can spend less time reading your screen. Choose the verbosity level that works for you. The setting is saved on the device.',
    label: 'Voice Picking'
  },
  pickComplete: {
    congratulations: 'Congratulations!',
    pickComplete: 'Pick Complete',
    allCartsInProgress: 'All carts appear to have a pick in progress.',
    clearCartInstructions:
      "If an available cart needs to be cleared you can scan one of it's totes to reset the cart so orders can be assigned.",
    newBatchInstructions:
      'You can begin picking a new batch by scanning any tote on a fresh, empty cart:',
    processOrdersInstructions:
      'To process the picked orders on this cart, please scan any of the occupied totes.',
    processScanInstructions: 'Please scan one of the highlighted totes.'
  },
  reversePickList: {
    buttonLabel: 'Reverse Pick List',
    toastReversed: 'Pick list reversed',
    toastRestored: 'Pick list order restored'
  },
  productGrid: {
    deleteConfirmTitle: 'Confirm Delete',
    deleteConfirmMessage:
      'All orders with these product(s) will be put On Hold. Are you sure you want to delete the selected products?',
    deleteConfirmYes: 'Yes, Delete',
    cancel: 'Cancel',
    unknownAction: 'Unknown action',
    selectProducts: 'Please select at least one product',
    deleteSuccess: 'Delete Queued Successfully',
    duplicateSuccess: 'Duplicate Queued Successfully',
    statusUpdateSuccess: 'Status Update Queued Successfully',
    generateBarcodeSuccess: 'Barcode generation in progress',
    generateNumericBarcodeSuccess: 'Numeric barcode generation in progress',
    printBarcodeLabelsSuccess: 'Barcode Labels will be generated shortly',
    printReceivingLabelsSuccess: 'Receiving Labels will be generated shortly',
    exportCsvSuccess:
      'Your request has been queued. You will receive an email when products export is complete',
    brokenImageExportSuccess: 'Successfully Queued',
    searchPlaceholder: 'Search products by SKU, name, or barcode...',
    createProduct: 'Create Product'
  },
  duplicatePickWarning: {
    title: 'Duplicate Pick Warning',
    message:
      'If you see this message while picking there is a good chance the label for this order has been printed twice and is at risk of being double shipped.',
    continueButton: "Continue, I know it's a re-shipment",
    reportButton: 'Report Possible Double Pick',
    question:
      'Are you performing a second verification (re-scanning) for this and other orders?',
    instructionPrefix: 'If so you can',
    instructionLink: 'click here',
    instructionSuffix: 'to silence notifications for this session.',
    activityLogAdded: 'Duplicate activity log added',
    cancelButton: 'Cancel'
  },
  zoneSettings: {
    title: 'Zone Settings',
    zonesLabel: 'Zones',
    addZoneLabel: 'Add a Zone',
    addRangeLabel: 'Add a Range',
    rangeStartLabel: 'Range Start',
    rangeEndLabel: 'Range End',
    rangeStartPlaceholder: 'e.g., A-1-1',
    rangeEndPlaceholder: 'e.g., D-6-60',
    zoneNamePrefix: 'Zone',
    editZoneTooltip:
      'Zones are locations that are physically near each other in the warehouse. Ideally the total volume of products will be spread somewhat evenly across zones rather than having most orders picked from one or two zones.',
    infoTooltip: 'Add bin location ranges for this zone below.',
    zoneAddedToast: '"{{zoneName}}" added successfully',
    zoneDeletedToast: '"{{zoneName}}" deleted',
    rangeAddedToast: 'Range added to {{zoneName}}',
    rangeDeletedToast: 'Range removed from {{zoneName}}',
    saveSuccessToast: 'Zone settings saved successfully',
    saveError: 'Failed to save zone settings',
    saveErrorToast: 'Failed to save zone settings',
    zoneAddError: 'Failed to add zone',
    zoneDeleteError: 'Failed to delete zone',
    nameAlreadyTaken: 'Zone name has already been taken'
  },
  savedFavouriteViews: {
    header: 'Saved & Favourite Views',
    selectEdit: 'Select/Edit Saved Views',
    savedViews: 'Saved Views',
    manageSavedViews: 'Manage Saved Views',
    saveCurrentFilters: 'Save Current Filters',
    savePromptMessage: 'Save current filters as:',
    savePromptPlaceholder: 'Enter view name',
    manageModalTitle: 'Manage Saved Views',
    save: 'Save',
    cancel: 'Cancel',
    setAsFavourite: 'Set as Favorite'
  },
  zoneAccess: {
    title: 'Zone Access',
    tooltip:
      'Always On zones will be included in order assignment automatically. Users have access to Optional zones and they can be enabled and disabled by users when they request orders to decrease route overlap. Disabled zones are essentially restricted, preventing orders in these zone from being assigned.',
    zone: 'Zone',
    zoneAccess: 'Zone Access',
    alwaysOn: 'Always On',
    optional: 'Optional',
    disabled: 'Disabled',
    saveAndClose: 'Save & Close',
    assignmentPreference: 'Zone assignment preference:',
    assignmentPreferenceTooltip:
      'Zone access can be adjusted for each cart so that only orders from selected zones will be assigned to the cart.\n\nThe default option is to control zone access by user so users will be assigned orders from specific zones.',
    carts: 'Carts',
    users: 'Users',
    alwaysOnIntro: '',
    alwaysOnDescription:
      ' zones will be included in order assignment automatically. Users have access to ',
    optionalZonesLabel: 'Optional zones',
    optionalZonesDescription:
      ' and they can be enabled and disabled by users when they request orders to decrease route overlap. ',
    disabledZonesLabel: 'Disabled zones',
    disabledZonesDescription:
      ' are essentially restricted, preventing orders in these zone from being assigned.',
    unableToIdentifyEntity:
      'Unable to identify user or cart. Please try again.',
    specifyZoneAccess: 'Please specify zone access for this cart',
    cartOptionalZoneTitle: '{{cartName}} – Optional zone access',
    noOptionalZones: 'No optional zones configured.'
  },
  unsavedChanges: {
    bannerMessage: 'You have unsaved changes',
    promptTitle: 'You have unsaved changes',
    promptMessage: 'Save your changes before leaving this page?',
    save: 'Save',
    saving: 'Saving…',
    discard: 'Discard'
  },
  adminTenantGrid: {
    title: 'Tenants',
    breadcrumbRoot: 'Admin Tools',
    duplicate: 'Duplicate',
    duplicateDisabledTooltip:
      'Select a tenant to duplicate it. A deleted tenant has to be restored first.',
    deleteDisabledTooltip:
      "Select a tenant to delete it. A tenant that's already deleted can be restored instead.",
    oneAtATimeTooltip:
      'This works on one tenant at a time. Select just one to turn it on.',
    tenantCount: {one: '1 tenant', other: '{{count}} tenants'},
    activeCount: '{{count}} active',
    deletedCount: '{{count}} deleted',
    loading: 'Loading tenants...',
    couldNotLoad: 'Could not load tenants',
    matchCount: {one: '1 match', other: '{{count}} matches'},
    searchPlaceholder: 'Search tenants',
    statusActive: 'Active',
    statusDeleted: 'Deleted',
    statusAll: 'All',
    allTenantSorting: 'All tenant sorting',
    allTenantSortingTooltip:
      'Sorts across all {{count}} tenants, not just this page. Slower.',
    selectedCount: '{{count}} selected',
    delete: 'Delete',
    restore: 'Restore',
    restoreDisabledTooltip:
      'Only deleted tenants can be restored. Select a deleted tenant to turn this on.',
    columns: 'Columns',
    columnsShown: '{{shown}} of {{total}}',
    columnsMore: '+ {{count}} more',
    loadFailedBanner: 'Failed to load tenants. Please try again.',
    retry: 'Retry',
    loadFailedTitle: "Couldn't load tenants",
    loadFailedBody:
      "The server didn't answer ({{status}}). The list isn't empty, it just didn't load, and nothing was changed. Last successful load was at {{time}}.",
    copyErrorDetails: 'Copy error details',
    emptyTitle: 'No tenants match "{{query}}"',
    emptyBody:
      'Nothing in {{count}} tenants matches that name, plan or store type. Check the spelling, or switch the status filter to include deleted tenants.',
    clearSearch: 'Clear search',
    pagerRange: '{{from}} to {{to}} of {{total}} tenants',
    rowsPerPage: 'Rows per page',
    notLoaded: 'Not loaded',
    noResults: '0 results',
    colTenant: 'Tenant',
    colPlan: 'Plan',
    colCreationStatus: 'Creation status',
    colTransactionErrors: 'Transaction errors',
    colStartDay: 'Start day',
    colShippedLastMonth: 'Shipped last period',
    colAvgShippedLastMonth: 'Avg per day, last period',
    colShippedThisMonth: 'Shipped this period',
    colAvgShippedThisMonth: 'Avg per day, this period',
    colPlanMax: 'Plan max',
    colUsers: 'Regular / admin-only users',
    colLastActivity: 'Last activity',
    colNotes: 'Notes',
    colUrl: 'URL',
    colStripe: 'Stripe',
    colTestTenant: 'Test tenant',
    colLastCharge: 'Last charge in Stripe',
    colLastImportStoreType: 'Last import store type',
    colAccountStatus: 'Account status',
    open: 'Open',
    noActivityYet: 'No activity yet',
    notChargedYet: 'Not charged yet',
    select: 'Select',
    selectAll: 'Select all',
    filtersTitle: 'Filters and sorting',
    filtersSubtitle: 'Applies to the Tenants list',
    filterStatus: 'Status',
    sortBy: 'Sort by',
    sortTenantAz: 'Tenant, A to Z',
    apply: 'Apply',
    reset: 'Reset',
    sortRegularUsers: 'Regular users',
    sortAdminOnlyUsers: 'Admin-only users',
    shippedOfMax: '{{shipped}} of {{max}}',
    previous: 'Previous',
    next: 'Next',
    closeSelection: 'Exit select mode',
    deleteConfirm: 'Delete {{name}}? Its data is kept and it can be restored.',
    restoreConfirm: 'Type the tenant name to restore it',
    duplicatePrompt: 'Name for the copy of {{name}}',
    deleteSummaryConfirm: 'Delete the import summary for {{name}}?',
    deleteSummary: 'Delete summary',
    deleteSummaryDisabledTooltip: 'Select a tenant to delete its import summary.',
    colCreated: 'Created',
    colWorkflow: 'Workflow',
    workflowDefault: 'Default',
    workflowScanToCart: 'Scan to Cart',
    workflowProductFirstPutWall: 'Product First Put Wall',
    workflowMultiPutWall: 'Multi Put Wall',
    workflowPickTote: 'Pick Tote',
    unlimited: 'Unlimited',
    planPerMonth: '{{amount}}/mo',
    planPerYear: '{{amount}}/yr',
    periodSince: 'since {{date}}',
    periodRange: '{{from}} to {{to}}',
    columnPrefsLoadFailed: "Couldn't load your saved columns, so the default set is showing. Column changes won't be saved until you reload the page.",
    columnPrefsSaveFailed: "Couldn't save your column choice: {{error}}",
    dash: '—'
  }
};
export default en;
